export const ROUTE_MAIN = 'main'
export const ROUTE_APPOINTMENT_CONFIRM = 'AppointmentConfirm'
export const ROUTE_APPOINTMENT_FAILURE = 'AppointmentFailure'
export const ROUTE_COOKIES_POLICY = 'CookiesPolicy'
export const ROUTE_EDIT_APPOINTMENT = 'SummaryEditView'
export const ROUTE_MODIFY_APPOINTMENT = 'ModifyAppointment'
export const ROUTE_REDIRECT_BRAND = 'redirectBrand'
export const ROUTE_ALREADY_HAS_APPOINTMENT = 'AlreadyHasAppointment'
